import * as Sentry from "@sentry/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Application } from "./Pages/App";
import { Forgot } from "./Pages/Auth/Forgot";
import { Login } from "./Pages/Auth/Login";
import { NewPassword } from "./Pages/Auth/NewPassword";
import { GlobalStyle } from "./styles/global";

function FallbackComponent() {
  return <div>Ocorreu um erro inesperado. Por favor, recarregue a página.</div>;
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/new-password/:token" element={<NewPassword />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Application />} />
        </Routes>
      </Router>
    </Sentry.ErrorBoundary>
  );
}

export default App;
